import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "../components/l10";

export const getElapsedTime = (elapsedHours: number, elapsedDays: number): string => {
  const { formatText } = useLocalization();
  switch (true) {
    case elapsedHours < 1:
      return formatText(locKeys.flightJustFoundText);
    case elapsedHours < 24:
      return formatText(locKeys.flightHoursAgoText, elapsedHours);
    default:
      return formatText(locKeys.flightDaysAgoText, elapsedDays);
  }
};
